import React from "react";
import useStore from "../store/useStore";

const FilterTag = ({ filter }) => {
  const setFilterState = useStore((state) => state.setFilterState);
  const activeFilterTagUids = useStore((state) => state.activeFilterTagUids);

  const checked = activeFilterTagUids.includes(filter.uid);

  const handleChange = () => {
    setFilterState(filter.uid, !checked);
  };

  const checkId = `${filter.uid}-${filter.name.toLowerCase()}`;

  return (
    <label className="filters__filter" htmlFor={checkId}>
      <input
        id={checkId}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />
      {filter.name}
    </label>
  );
};

export default FilterTag;
